export enum CourseType {
  CreditCounseling = 1,
  DebtorEducation = 2
}

export enum CourseStatus {
  ChooseCourse = 1,
  PendingRegistration = 2,
  PendingNotStarted = 3,
  PendingCourseStarted = 4,
  PendingCertification = 5,
  Complete = 6,
  Canceled = 7,
  Expired = 8,
  CourseOrderedForSpouse = 9,
  CompleteCertificateManuallyUploaded = 10,
  Unknown = 11,
  PendingRegistrationPhone = 12,
  PendingNotStartedPhone = 13
}

export enum ForJointCaseOrders {
  OneCourseTakingTogether = 1,
  TwoCoursesTakingSeparately = 2,
  OneCourseDebtor1Only = 3,
  OneCourseDebtor2Only = 4
}

export enum CourseProvider {
  CricketDebtCounseling = 245,
  DebtEducationAndCertificationFoundation = 176,
  DebtEducationandCertificationFoundation = 177,
  DebtHelperCreditCounseling = 291,
  SecondBankruptcyCourse = 246,
  UrgentCreditCounseling = 294
}

export function isCourseChoosen(orderItem: CourseOrderItem): boolean {
  if (orderItem) {
    if (orderItem.courseStatus === CourseStatus.PendingRegistration) {
      return true
    }
    if (orderItem.courseStatus === CourseStatus.PendingRegistrationPhone) {
      return true
    }
    if (orderItem.courseStatus === CourseStatus.PendingNotStartedPhone) {
      return true
    }
    if (orderItem.courseStatus === CourseStatus.PendingNotStarted) {
      return true
    }
    if (orderItem.courseStatus === CourseStatus.PendingCourseStarted) {
      return true
    }
    if (orderItem.courseStatus === CourseStatus.PendingCertification) {
      return true
    }
    if (orderItem.courseStatus === CourseStatus.Complete) {
      return true
    }
    if (orderItem.courseStatus === CourseStatus.Canceled) {
      return true
    }
    if (orderItem.courseStatus === CourseStatus.Expired) {
      return true
    }
  }
  return false
}

export function getCourseStatusName(
  status: CourseStatus,
  showPending = false
): string {
  if (status === CourseStatus.ChooseCourse) {
    return 'Choose Course'
  } else if (status === CourseStatus.PendingRegistration) {
    return 'Registration'
  } else if (status === CourseStatus.PendingRegistrationPhone) {
    if (showPending) {
      return 'Pending Registration'
    } else {
      return 'Registration'
    }
  } else if (status === CourseStatus.PendingNotStartedPhone) {
    if (showPending) {
      return 'Pending Registration'
    } else {
      return 'Registration'
    }
  } else if (status === CourseStatus.PendingNotStarted) {
    return 'Course Not Started'
  } else if (status === CourseStatus.PendingCourseStarted) {
    return 'Course Started'
  } else if (status === CourseStatus.PendingCertification) {
    return 'Certification'
  } else if (status === CourseStatus.Complete) {
    return 'Complete'
  } else if (status === CourseStatus.Canceled) {
    return 'Canceled'
  } else if (status === CourseStatus.Expired) {
    return 'Expired'
  } else if (status === CourseStatus.CompleteCertificateManuallyUploaded) {
    return 'Complete - Certificate Manually Uploaded'
  }
  return 'Unknown'
}

export function getCourseForJointCaseOrdersDescription(
  courseForJointCaseOrders: ForJointCaseOrders | null | undefined
): string {
  if (courseForJointCaseOrders) {
    if (
      courseForJointCaseOrders == ForJointCaseOrders.OneCourseTakingTogether
    ) {
      return 'Taking course with spouse'
    } else {
      return 'Taking course without spouse'
    }
  }
  return ''
}

export function isCourseRegisteredOrInProgress(status: CourseStatus): boolean {
  if (status === CourseStatus.ChooseCourse) {
    return false
  }
  if (status === CourseStatus.CourseOrderedForSpouse) {
    return false
  }

  return true
}

export enum CoursePaymentType {
  ClientPays = 1,
  FirmPays = 2
}

export enum CourseMethodType {
  Online = 1,
  Phone = 2
}

export interface CourseInviteProvider {
  orderItemId: number | null
  productKey: number
  name: string
  price: string | null
  valueProps: string | null
}

export interface CourseInvite {
  courseNumber: string
  orderId: number
  coursePaymentType: CoursePaymentType
  courseProviders: CourseInviteProvider[]
}

export interface CourseOrderItem {
  courseNumber: string
  orderId: number
  orderItemId: number
  isJoint: boolean
  providerId: number
  providerName: string
  courseType: CourseType
  courseStatus: CourseStatus
  courseMethod: CourseMethodType
  coursePaymentType: CoursePaymentType
  coursePrice: string | null
  coursePhoneNumber: string | null
  courseAccessCode: string | null
  courseCompletionDate: string | null
  courseCertificationExpirationDate: string | null
  verifiedDetails: boolean
  verifiedCoDebtorDetails: boolean
  acceptedDisclosureAgreement: boolean
  shownCourseInstructions: boolean
  hasRegisteredCourse: boolean
}

export interface CourseDashboardResult {
  invites: CourseInvite[]
  orders: CourseOrderItem[]
}

export interface CourseDiscInstUrlInfo {
  courseNumber: string
  courseOrderItemId: number
  courseUrl: string
  instructions: string
  disclosureContent: string
  disclosureVersion: number
  info1: string | null
  info2: string | null
}

export interface UpdateCourseDiscInstUrlInfoWithRegistration {
  courseNumber: string
  courseUrl: string
  info1: string | null
  info2: string | null
  courseStatus: number
}

export interface OrderCustomerDetails {
  caseId: number
  orderId: number
  orderKey: number
  personId: number
  firstName: string | null
  lastName: string | null
  middleName: string | null
  suffix: string | null
  homePhone: string | null
  mobilePhone: string | null
  workPhone: string | null
  emailAddress: string | null
  street: string | null
  zip: string | null
  city: string | null
  state: string | null
}

export enum CourseTabTitle {
  CANCELED_FIRST_COURSE = 'First Course Canceled',
  CANCELED_SECOND_COURSE = 'Second Course Canceled',
  COURSE_FOR_SPOUSE = 'Course Ordered for Spouse',
  COURSE_NOT_ORDERED = 'Course Not Ordered',
  FINISHED_FIRST_COURSE = "Congratulations! You've finished the first course!",
  FINISHED_SECOND_COURSE = "Congratulations! You've finished the second course!",
  TAKE_FIRST_COURSE = 'Take the First Course',
  TAKE_SECOND_COURSE = 'Take the Second Course'
}
